import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/liquidacionPredial',
    name: 'LiquidacionPredial',
    component: () => import('../views/LiquidacionPredial.vue')
  },
  {
    path: '/liquidacionInyCo',
    name: 'LiquidacionInyCo',
    component: () => import('../views/LiquidacionInyCo.vue')
  },
  {
    path: '/liquidacionInyCoDeclaLiq',
    name: 'LiquidacionInyCoDeclaLiq',
    component: () => import('../views/LiquidacionInyCo.vue'),
    props: route => ({
      mm: route.params.mm,
      liq: route.params.liq,
    }),
  },
  {
    path: '/validate',
    name: 'Validate',
    component: () => import('../views/Validate.vue')
  },
    {
    path: '/preguntasfrecuentesptp',
    name: 'PreguntaFrecuentesPTP',
    component: () => import('../views/PreguntaFrecuentesPTP.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
